import { FooterSection } from "@/templates/sections/FooterSection"
import { wrapWithBackgroundIfNeeded, type BlockComponentProps } from "./shared"

/**
 * On the public site, footer is rendered by PublicFooter (reads live data).
 * Only render FooterSection in the builder where it's editable.
 */
export function FooterBlock({ content, customizations, org, inBuilder, styleOverrides }: BlockComponentProps) {
  if (!inBuilder) return null
  return (
    <>
      {wrapWithBackgroundIfNeeded(
        content,
        <FooterSection
          content={content}
          customizations={customizations}
          org={org}
          inBuilder={inBuilder}
          styleOverrides={styleOverrides}
        />
      )}
    </>
  )
}
